import AccessLogRequest from './access_log_request';

export default AccessLogRequest;
